module.exports = __webpack_public_path__ + "img/umbilical.0c985d67.png";